import React, { createContext, useState, useContext } from 'react';

const NavContext = createContext(null);

export const NavProvider = ({ children }) => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  return (
    <NavContext.Provider value={{ isNavCollapsed, setIsNavCollapsed }}>
      {children}
    </NavContext.Provider>
  );
};

export const useNav = () => {
  const context = useContext(NavContext);
  if (!context) {
    throw new Error('useNav must be used within a NavProvider');
  }
  return context;
}; 